export default __webpack_public_path__ + "static/char-s-02-en-246c8002d8cbf1e82cb8c8db68cb6230.png";